import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { collaborationPrivateRoutesConstants as routesConstants } from "./routesConstants";

import { componentLazyImport } from "modules/core/utils/helpers";

// Pages
const Todos = lazy(() =>
  componentLazyImport(() => import("modules/collaboration/pages/Todos"))
);

const EERoadmap = lazy(() =>
  componentLazyImport(() => import("modules/collaboration/pages/EERoadmap"))
);

const Brainstorming = lazy(() =>
  componentLazyImport(() => import("modules/collaboration/pages/Brainstorming"))
);

const CollaborationPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.todos.path} exact>
        <Todos />
      </Route>

      <Route path={routesConstants.brainstorming.path} exact>
        <Brainstorming />
      </Route>

      <Route path={routesConstants.ee_roadmap.path} exact>
        <EERoadmap />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default CollaborationPrivateRoutes;
